import React from 'react';
import '../App.css';
import { useForm } from 'react-hook-form';
import { useNavigate,useLocation } from 'react-router-dom';
import { ApiUrl } from '../App';

type FormData = {
  test_info: string;
};

const InputData: React.FC = () => {
  const { register, handleSubmit } = useForm<FormData>();
  const navigate = useNavigate();

  const location = useLocation();
  let email         = location.state.email;
  let access_token  = location.state.access_token;
  console.log(email);
  console.log(access_token);

 // const onSubmit = handleSubmit((data) => console.log(data));
  const onSubmit = handleSubmit((data) => {
	  console.log('----');
	  const info1 = data.test_info;
	  console.log(info1);
	  console.log('----');

	  const formData = new URLSearchParams();
	  formData.append("email"   ,email);
	  formData.append("test_info",info1);
	  const body = formData.toString();

	  const url = ApiUrl + "users/settings/update";
	  console.log(url);

	  fetch(url, {
  		method: "POST",
		headers:{
			'Authorization': 'Bearer ' + access_token,
			'Content-Type': 'application/x-www-form-urlencoded'
		},
  		body:  body,
	     })
	    .then(response => response.json())
    	    .then(data => {
        	    console.log('Success:', data);
		    const fOk: boolean = data.data.success;
        	    console.log('Success fOK:', fOk);
		    if ( fOk ) {
        	    	console.log('Success OK:', data);
	  		navigate('/ended', { state:{
            			message: data.data.message,
          			}})
		    }else{
        	        console.log('in Error:', data);
        	        console.log('in Error:', data.data.response);
	  		navigate('/mes', { state:{
            			message: data.data.response,
          			}})
		    }
    	    })
    	    .catch((error) => {
        	    console.error('Error:', error);
	  	    navigate('/mes' ,{ state:{
            			message: error,
          		}})
    	    });
  });

  return (
    <div className="App">
      <center>
      <h1>登録するデータを入力してください。</h1>
      <table width="60%">
      <tr><td>
      <form onSubmit={onSubmit}>
        <div>
	<center>
          <label htmlFor="test_info"> とある情報　</label>
          <input id="test_info" {...register('test_info')} />
	</center>
        </div>
	<br/>
	<center>
        <button type="submit"  color="#f194ff" >
	この情報で登録する。</button>
	</center>
      </form>
      </td></tr>
      <tr><td>
      <center>
      <br/>
      <br/>
      <br/>
      .....test<br/>
      <br/>
      </center>
      </td></tr>
      </table >
      </center>
    </div>
  );
}

export default InputData;

